<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Scrollable content below header -->
<div class="modal-scroll-content" [hidden]="minimise">

<div class="modal-body">

  <!-- Key Info (code-combo-box-key style) -->
  @if (codeCombination) {
<div class="key-info">
    <i class="fa fa-shield fa-lg"></i>
    Key: {{codeCombination.LEID}} - {{codeCombination.CDR_NO}} - {{codeCombination.REPORTING_PERIOD}} - {{codeCombination.ME_CODE}} - {{codeCombination.LEDGER}} - {{codeCombination.CURR}} - {{codeCombination.CHART_CODE}}
  </div>
}

  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- Form -->
  @if (!showFormLoader && showTaxAdjForm) {
<div class="tax-adj-form">
    <form #taxAdjForm="ngForm" novalidate autocomplete="off">

      <!-- System Summary -->
      @if (gridType === 'SYSTEM_BOOK_TO_TAX_SUMMARY') {
<div class="systemSummary">
        <div class="leftText nowrap">
          <strong>System Account</strong> - {{rowData.SYSTEM_ACCT}} - {{rowData.SYSTEM_ACCT_DESC}}
        </div>
      </div>
}

      <!-- ======================= FIR TEMPLATE ======================= -->
      @if (SOURCE_SYSTEM === 'FIR') {


        <!-- Adjustment Type Radio Buttons -->
        <div class="adj-type-row">
          <label class="radio-inline font-weight-bold"><strong>Adjustment Type</strong></label>
          <label class="radio-inline font-weight-bold">
            <input type="radio"
                   name="rd_fir_trans_type"
                   value="LOCAL_TAX_ADJ"
                   [(ngModel)]="FIR_TRANS_TYPE"
                   (change)="updateFirTransType('LOCAL_TAX_ADJ')">
            E&P Adjustment
          </label>
          <label class="radio-inline font-weight-bold">
            <input type="radio"
                   name="rd_fir_trans_type"
                   value="LOCAL_TAX_ADJ_GHOST"
                   [(ngModel)]="FIR_TRANS_TYPE"
                   (change)="updateFirTransType('LOCAL_TAX_ADJ_GHOST')">
            Tax Adjustment
          </label>
        </div>

        <hr>

        <!-- Income Statement Local Account & 5471 Schd H Line -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Income Statement Local Acct</label>
          <div class="col-md-3">
            @if (loadingSysAcct) {
<div class="gt-filter-loading">
              <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
            </div>
}
            @if (!loadingSysAcct) {

              @if (parentObject.IS_ACCT_EDITABLE === 'Y') {

                <select gtwSearchableSelect class="form-control input-sm"
                        name="parent_account"
                        [(ngModel)]="parentAcct"
                        [compareWith]="compareByLocalAcctKey"
                        (change)="setParentAccount(parentAcct)"
                        required>
                  <option [ngValue]="null">Select Account...</option>
                  @for (acc of localAccDropdownData; track $index) {
<option [ngValue]="acc">
                    {{acc.ACCT_DD_DISPLAY || (acc.LOCAL_ACCT + ' - ' + acc.LOCAL_ACCT_DESC)}}
                  </option>
}
                </select>
              
}
              @if (parentObject.IS_ACCT_EDITABLE === 'N') {

                <input readonly type="text" class="form-control input-sm" [value]="parentObject.ACCT_DD_DISPLAY">
              
}
            
}
          </div>

          <label class="col-md-3 control-label font-weight-bold">
            @if (lineFlag) {
<span>5471 Schd H Line:</span>
}
            @if (!lineFlag) {
<span>8865 Sch M1 Line:</span>
}
          </label>
          <div class="col-md-3">
            @if (loadingLines) {
<div class="gt-filter-loading">
              <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
            </div>
}
            @if (!loadingLines) {
<select gtwSearchableSelect
                    class="form-control input-sm"
                    name="schdhClassification"
                    [(ngModel)]="selectedLine"
                    [compareWith]="compareByLineNo"
                    (change)="changeSchd(selectedLine)"
                    required>
              <option [ngValue]="null">Select Line...</option>
              @for (line of lineDetailsData; track $index) {
<option [ngValue]="line">
                {{line.DESCRIPTION}}
              </option>
}
            </select>
}
          </div>
        </div>

        <!-- Tax Adj Description & Line No -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Tax Adj Description</label>
          <div class="col-md-3">
            <input type="text"
                   class="form-control input-sm"
                   name="adj_desc"
                   [(ngModel)]="ADJ_DESCRIPTION"
                   placeholder=""
                   required
                   maxlength="250"
                   (keyup)="validateDesc()"
                   (blur)="removeMessage()">
            @if (formSubmitted && (!ADJ_DESCRIPTION || ADJ_DESCRIPTION.trim() === '')) {
<span class="form-error-container">
              Adjustment Description is required.
            </span>
}
            @if (isMaxLimitReached) {
<span class="form-error-container">
              You have reached the maximum limit of characters allowed
            </span>
}
          </div>

          <label class="col-md-3 control-label font-weight-bold">Line No:</label>
          <div class="col-md-3">
            <label class="control-label font-weight-bold">{{parentObject.SCHD_H_LINE_NO}}</label>
          </div>
        </div>

        <!-- Adjustment Amount & Trading Partner -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Adjustment Amount:</label>
          <div class="col-md-3">
            <input type="number"
                   class="form-control input-sm text-right"
                   name="adj_amount"
                   [(ngModel)]="parentObject.ADJ_AMT">
          </div>

          <label class="col-md-3 control-label font-weight-bold">Trading Partner:</label>
          <div class="col-md-3">
            <div class="autocomplete-wrapper">
              <div class="input-group">
                <input type="text"
                       class="form-control input-sm"
                       [value]="firTpSearchText"
                       placeholder="begin typing to select trading partner"
                       (input)="searchFirTradingPartners($event)"
                       name="tradingPartnerFir">
                <span class="input-group-addon">
                  @if (loadingFirTp) {
<i class="fa fa-spinner fa-pulse"></i>
}
                  @if (!loadingFirTp) {
<i class="fa fa-search"></i>
}
                </span>
              </div>
              @if (firTpSearchResults.length > 0) {
<div class="autocomplete-dropdown">
                @for (tp of firTpSearchResults; track $index) {
<div class="autocomplete-item"
                     (mousedown)="selectFirTradingPartner(tp)">
                  {{tp.TP_ENTITY}}
                </div>
}
              </div>
}
            </div>
          </div>
        </div>

        <!-- Supplemental Info -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Supplemental Information:</label>
          <div class="col-md-3">
            <input type="text"
                   class="form-control input-sm"
                   name="suppl_info"
                   [(ngModel)]="SUPPL_INFO"
                   placeholder="">
          </div>
        </div>

        <!-- Project Name & Project Step -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Project Name:</label>
          <div class="col-md-3">
            @if (loadingProjects) {
<div class="gt-filter-loading">
              <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
            </div>
}
            @if (!loadingProjects) {
<select gtwSearchableSelect
                    class="form-control input-sm"
                    name="projectLists"
                    [(ngModel)]="projectsList.selected"
                    [compareWith]="compareByProjectId"
                    (change)="changeProject()">
              <option [ngValue]="null">Select a Project Name</option>
              @for (project of projectsList.list; track $index) {
<option [ngValue]="project">
                {{project.PROJECT_NAME}}
              </option>
}
            </select>
}
          </div>
          <label class="col-md-3 control-label font-weight-bold">Project Step Code:</label>
          <div class="col-md-3">
            <select gtwSearchableSelect class="form-control input-sm"
                    name="projectSteps"
                    [(ngModel)]="projectSteps.selected"
                    [compareWith]="compareByProjectStepId"
                    (change)="changeProjectStep()">
              <option [ngValue]="null">Select a Project Step</option>
              @for (step of projectSteps.list; track $index) {
<option [ngValue]="step">
                {{step.STEP_SHORT_DESCRIPTION}}
              </option>
}
            </select>
          </div>
        </div>

        <!-- Auto Reverse -->
        <div class="form-group form-row">
          <label class="col-md-3 control-label font-weight-bold">Auto reverse in next year?</label>
          <div class="col-md-3">
            <input type="checkbox"
                   name="auto_reverse"
                   [ngModel]="parentObject.AUTO_REVERSE_YN === 'Y'"
                   (ngModelChange)="parentObject.AUTO_REVERSE_YN = $event ? 'Y' : 'N'"
                   [ngModelOptions]="{standalone: true}">
          </div>
        </div>

        <!-- Existing Offset Adjustments (shown in edit mode) -->
        @if (existingOffsetAdjustments.length && isEdit) {
<div>
          <div class="row"><hr></div>
          <div style="margin-left: 30px; margin-right: 30px;">
            <div><span><strong>Existing Balance Sheet Details</strong></span></div>
            <div class="table-responsive">
              <table class="table table-hover table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th>Delete</th>
                    <th>Balance Sheet Acct</th>
                    <th>Trading Partner</th>
                    <th>Balance Sheet Amount</th>
                  </tr>
                </thead>
                <tbody>
                  @for (offsetAdj of existingOffsetAdjustments; track $index) {
<tr>
                    <td class="text-bg" align="center">
                      <a href="javascript:void(0)" (click)="deleteAdjustment(offsetAdj, 'OFFSET')">
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                    <td>{{offsetAdj.LOCAL_ACCT}} - {{offsetAdj.LOCAL_ACCT_DESC}}</td>
                    <td>{{offsetAdj.TP_ENTITY}}</td>
                    <td class="text-right">
                      <input type="number" class="form-control text-right input-sm"
                             [(ngModel)]="offsetAdj.ADJ_AMT"
                             [name]="'existing_offset_amt_' + offsetAdj.OBJECT_ID">
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
        </div>
}

        <div class="row"><hr></div>

        <!-- Balance Sheet Offset Headers -->
        <div class="row">
          <div class="col-md-3"><label class="font-weight-bold">Balance Sheet Acct</label></div>
          <div class="col-md-3"><label class="font-weight-bold">Trading Partner</label></div>
          <div class="col-md-2"><label class="font-weight-bold">Balance Sheet Amt</label></div>
        </div>

        <!-- Offset Rows -->
        @for (offset of addOffsetRows; track $index; let i = $index) {
<div class="row" style="margin-bottom: 5px;">
          <div class="col-md-3">
            <div class="autocomplete-wrapper">
              <div class="input-group">
                <input type="text"
                       class="form-control input-sm"
                       [value]="offset.ACCT_DD_DISPLAY || ''"
                       placeholder="begin typing to select account"
                       (input)="offset.ACCT_DD_DISPLAY = $any($event.target).value; searchOffsetAccounts($event, i)"
                       [name]="'offset_account_' + i">
                <span class="input-group-addon">
                  @if (loadingOffsetAcct[i]) {
<i class="fa fa-spinner fa-pulse"></i>
}
                  @if (!loadingOffsetAcct[i]) {
<i class="fa fa-search"></i>
}
                </span>
              </div>
              @if (offsetAcctSearchResults[i] && offsetAcctSearchResults[i].length > 0) {
<div class="autocomplete-dropdown">
                @for (acc of offsetAcctSearchResults[i]; track $index) {
<div class="autocomplete-item"
                     (mousedown)="selectOffsetAccount(acc, i)">
                  {{acc.ACCT_DD_DISPLAY || (acc.LOCAL_ACCT + ' - ' + acc.LOCAL_ACCT_DESC)}}
                </div>
}
              </div>
}
            </div>
          </div>
          <div class="col-md-3">
            <div class="autocomplete-wrapper">
              <div class="input-group">
                <input type="text"
                       class="form-control input-sm"
                       [value]="offset.tpDisplay || ''"
                       placeholder="begin typing to select trading partner"
                       (input)="offset.tpDisplay = $any($event.target).value; searchOffsetTradingPartners($event, i)"
                       [name]="'offset_tp_' + i">
                <span class="input-group-addon">
                  @if (loadingOffsetTp[i]) {
<i class="fa fa-spinner fa-pulse"></i>
}
                  @if (!loadingOffsetTp[i]) {
<i class="fa fa-search"></i>
}
                </span>
              </div>
              @if (offsetTpSearchResults[i] && offsetTpSearchResults[i].length > 0) {
<div class="autocomplete-dropdown">
                @for (tp of offsetTpSearchResults[i]; track $index) {
<div class="autocomplete-item"
                     (mousedown)="selectOffsetTradingPartner(tp, i)">
                  {{tp.TP_ENTITY}}
                </div>
}
              </div>
}
            </div>
          </div>
          <div class="col-md-2">
            <input type="number"
                   class="form-control input-sm text-right"
                   [name]="'offset_amt_' + i"
                   [(ngModel)]="offset.ADJ_AMT">
          </div>
        </div>
}

        <!-- Add Offset Button -->
        <div class="row">
          <div class="col-md-1">
            <i (click)="addOffsetAccount()"
               class="fa fa-plus-circle color-green"
               style="cursor: pointer; font-size: 18px;"
               title="Add Balance Sheet Offset Account"></i>
          </div>
        </div>

      
}
      <!-- ======================= END FIR TEMPLATE ======================= -->

      <!-- ======================= DCS TEMPLATE ======================= -->
      @if (SOURCE_SYSTEM === 'DCS') {


        <!-- DCS Tabs -->
        <div class="dcs-tabs">
          @if (activeScheduleTab === 0) {

            <button type="button" class="btn btn-sm btn-primary">SCHDM Adjustments</button>
            <a href="javascript:void(0)" class="tab-link" (click)="reclassCall()">Book Only Reportable</a>
          
}
          @if (activeScheduleTab === 1) {

            <a href="javascript:void(0)" class="tab-link" (click)="reclassCall1()">SCHDM Adjustments</a>
            <button type="button" class="btn btn-sm btn-primary">Book Only Reportable</button>
          
}
        </div>

        <!-- ======================= SCHDM Adjustments Tab ======================= -->
        @if (activeScheduleTab === 0) {
<div class="schdm-tab-content">
          
          <!-- Top Section: Posting Accounts & Amounts -->
          <div class="dcs-header-section" style="margin: 15px;">
            <div class="row" style="margin-top: 5px;">
              <!-- Posting G/L Account -->
              @if (!testFlag) {
<div class="col-md-4">
                <label class="font-weight-bold">Posting G/L Account</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="postingGL" name="postingGL" readonly>
}
              </div>
}
              @if (testFlag) {
<div class="col-md-4">
                <label class="font-weight-bold">Posting Tax Account Code</label>
                <select gtwSearchableSelect class="form-control" [(ngModel)]="postingTaxTop" name="postingTaxTop" (change)="newPostingTaxChange()">
                  @for (acct of postingGLAcctM; track $index) {
<option [ngValue]="acct">{{acct}}</option>
}
                </select>
                @if (postingTaxAccountCodeError) {
<span class="form-error-container">Please Select a Posting Tax Account Code</span>
}
              </div>
}

              <!-- Posting Tax Account Code -->
              @if (!testFlag) {
<div class="col-md-4">
                <label class="font-weight-bold">Posting Tax Account Code</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="postingTax" name="postingTax" readonly>
}
              </div>
}

              <!-- M3 Form Line -->
              @if (!testFlag) {
<div class="col-md-4">
                <label class="font-weight-bold">M3 Form Line</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="m3FormLine" name="m3FormLine" readonly>
}
              </div>
}
              @if (testFlag) {
<div class="col-md-4">
                <label class="font-weight-bold">M3 Form Line</label>
                @if (!triggerLoadingNew) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoadingNew) {
<input type="text" class="form-control" [(ngModel)]="m3FormLine" name="m3FormLineNew" readonly>
}
              </div>
}
            </div>

            <!-- Book Amt, Book Adj, Tax Adj Row -->
            @if (!testFlag) {
<div class="row" style="margin-top: 5px;">
              <div class="col-md-4">
                <label class="font-weight-bold">Book Amt</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<div class="input-group">
                  <span class="input-group-addon">{{dcsCurr}}</span>
                  <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(bookAmt)" name="bookAmt" readonly>
                </div>
}
              </div>
              <div class="col-md-4">
                <label class="font-weight-bold">Book Adj</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<div class="input-group">
                  <span class="input-group-addon">{{dcsCurr}}</span>
                  <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(bookAdj)" name="bookAdj" readonly>
                </div>
}
              </div>
              <div class="col-md-4">
                <label class="font-weight-bold">Tax Adj</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<div class="input-group">
                  <span class="input-group-addon">{{dcsCurr}}</span>
                  <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(taxAdj)" name="taxAdj" readonly>
                </div>
}
              </div>
            </div>
}
          </div>

          <!-- Mandatory Fields Accordion -->
          <div class="panel panel-default wwni-map-accordion">
            <div class="panel-heading" (click)="mandatoryFieldsOpen = !mandatoryFieldsOpen" style="cursor: pointer;">
              Mandatory Fields
              <i class="pull-right glyphicon" [ngClass]="{'glyphicon-chevron-down': mandatoryFieldsOpen, 'glyphicon-chevron-up': !mandatoryFieldsOpen}"></i>
            </div>
            @if (mandatoryFieldsOpen) {
<div class="panel-body">
              
              <!-- Template, User M-1 Description, SchdM Type, TBBS Acct (editable mode) -->
              @if (hideMandatoryFieldCP) {
<div class="row">
                <div class="col-md-3">
                  <label class="font-weight-bold">Template</label>
                  @if (templateLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!templateLoading) {
<select gtwSearchableSelect class="form-control" [(ngModel)]="template" name="template" (change)="changeTemplate()">
                    <option value="">Select...</option>
                    @for (t of tempSystemAccount; track $index) {
<option [value]="t">{{t}}</option>
}
                  </select>
}
                  @if (templateError) {
<span class="form-error-container">Please Select a Template</span>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">User M-1 Description</label>
                  @if (template && template !== '----------Preferred Templates---------' && template !== '-------Non Preferred Templates-------') {
<input
                         type="text" class="form-control" [(ngModel)]="userM1" name="userM1" (change)="m1Desc()" required>
}
                  @if (!template || template === '----------Preferred Templates---------' || template === '-------Non Preferred Templates-------') {
<input
                         type="text" class="form-control" [(ngModel)]="userM1" name="userM1Readonly" (change)="m1Desc()" required readonly>
}
                  @if (userDescError) {
<span class="form-error-container">User M-1 Description is required</span>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">SchdM Type</label>
                  @if (schdMLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!schdMLoading) {

                    @if (template && template !== '----------Preferred Templates---------' && template !== '-------Non Preferred Templates-------') {
<select gtwSearchableSelect
                            class="form-control" [(ngModel)]="schdMt" name="schdMt" (change)="typeChange()">
                      <option value="">Select...</option>
                      @for (type of schdMType; track $index) {
<option [value]="type">{{type}}</option>
}
                    </select>
}
                    <!-- Legacy fallback (userm1 reused intentionally) when template not selectable -->
                    @if (!template || template === '----------Preferred Templates---------' || template === '-------Non Preferred Templates-------') {
<input
                           type="text" class="form-control" [(ngModel)]="userM1" name="schdMtUserM1Fallback" (change)="m1Desc()" required readonly>
}
                  
}
                  @if (typeError) {
<span class="form-error-container">Please Select a SchdM type</span>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">TBBS Acct</label>
                  @if (tbbsLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!tbbsLoading) {

                    @if (template && template !== '----------Preferred Templates---------' && template !== '-------Non Preferred Templates-------') {
<select gtwSearchableSelect
                            class="form-control" [(ngModel)]="tbbsAcctVal" name="tbbsAcctVal" (change)="tbbsChange()">
                      <option value="">Select...</option>
                      @for (acct of tbbsAcct; track $index) {
<option [value]="acct">{{acct}}</option>
}
                    </select>
}
                    <!-- Legacy fallback (userm1 reused intentionally) when template not selectable -->
                    @if (!template || template === '----------Preferred Templates---------' || template === '-------Non Preferred Templates-------') {
<input
                           type="text" class="form-control" [(ngModel)]="userM1" name="tbbsAcctUserM1Fallback" (change)="m1Desc()" required readonly>
}
                  
}
                  @if (tbbsError) {
<span class="form-error-container">Please Select a TBBS acct</span>
}
                </div>
              </div>
}

              <!-- Template, User M-1 Description, SchdM Type, TBBS Acct (readonly mode) -->
              @if (!hideMandatoryFieldCP) {
<div class="row">
                <div class="col-md-3">
                  <label class="font-weight-bold">Template</label>
                  <input type="text" class="form-control" [(ngModel)]="template" name="templateReadonly" readonly>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">User M-1 Description</label>
                  <input type="text" class="form-control" [(ngModel)]="userM1" name="userM1ReadonlyMode" readonly>
                </div>
                @if (!hideMandatoryFieldCSchdmType) {
<div class="col-md-3">
                  <label class="font-weight-bold">SchdM Type</label>
                  @if (schdMLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!schdMLoading) {

                    @if (template && template !== '----------Preferred Templates---------' && template !== '-------Non Preferred Templates-------') {
<select gtwSearchableSelect
                            class="form-control" [(ngModel)]="schdMt" name="schdMtEdit" (change)="typeChange()">
                      <option value="">Select...</option>
                      @for (type of schdMType; track $index) {
<option [value]="type">{{type}}</option>
}
                    </select>
}
                    <!-- Legacy fallback (userm1 reused intentionally) when template not selectable -->
                    @if (!template || template === '----------Preferred Templates---------' || template === '-------Non Preferred Templates-------') {
<input
                           type="text" class="form-control" [(ngModel)]="userM1" name="schdMtEditUserM1Fallback" (change)="m1Desc()" required readonly>
}
                  
}
                  @if (typeError) {
<span class="form-error-container">Please Select a SchdM type</span>
}
                </div>
}
                @if (hideMandatoryFieldCSchdmType) {
<div class="col-md-3">
                  <label class="font-weight-bold">SchdM Type</label>
                  <input type="text" class="form-control" [(ngModel)]="schdMt" name="schdMtReadonlyMode" readonly>
                </div>
}
                <div class="col-md-3">
                  <label class="font-weight-bold">TBBS Acct</label>
                  <input type="text" class="form-control" [(ngModel)]="tbbsAcctVal" name="tbbsAcctValReadonlyMode" readonly>
                </div>
              </div>
}

              <!-- PY Schd M-1 Amount, CY Schd M-1 Amount, Recurring, No Book Amount (editable mode) -->
              @if (hideMandatoryFieldCP) {
<div class="row" style="margin-top: 5px;">
                <div class="col-md-3 numText">
                  <label class="font-weight-bold">PY Schd M-1 Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(parentObject.PRIOR_YEAR_AMT)" name="priorYearAmt" readonly>
                  </div>
                </div>
                <div class="col-md-3 numText">
                  <label class="font-weight-bold">CY Schd M-1 Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    <input style="text-align: right" type="number" class="form-control" [(ngModel)]="CURRENT_YR_AMT" name="currentYrAmt" (change)="cyAmount()">
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Click Here if This is a Recurring Schedule M-1</label>
                  <input style="margin-top: 10px; margin-right: 5px" type="checkbox" [(ngModel)]="recurring" name="recurring">
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Check here if this Schedule M-1 has No Book Amount</label>
                  <input style="margin-top: 10px; margin-right: 5px" type="checkbox" [(ngModel)]="bookAmtExist" name="bookAmtExist">
                </div>
              </div>
}

              <!-- PY Schd M-1 Amount, CY Schd M-1 Amount, Recurring, No Book Amount (readonly mode) -->
              @if (!hideMandatoryFieldCP) {
<div class="row" style="margin-top: 5px;">
                <div class="col-md-3 numText">
                  <label class="font-weight-bold">PY Schd M-1 Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(parentObject.PRIOR_YEAR_AMT)" name="priorYearAmtReadonly" readonly>
                  </div>
                </div>
                <div class="col-md-3 numText">
                  <label class="font-weight-bold">CY Schd M-1 Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(CURRENT_YR_AMT)" name="currentYrAmtReadonly" readonly>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Click Here if This is a Recurring Schedule M-1</label>
                  <input style="margin-top: 10px; margin-right: 5px" type="checkbox" [(ngModel)]="recurring" name="recurringReadonly" disabled>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Check here if this Schedule M-1 has No Book Amount</label>
                  <input style="margin-top: 10px; margin-right: 5px" type="checkbox" [(ngModel)]="bookAmtExist" name="bookAmtExistReadonly" disabled>
                </div>
              </div>
}

              <!-- SchdM Reviewed, User Reviewed, Reviewed On (editable mode) -->
              @if (hideMandatoryFieldCP) {
<div class="row" style="margin-top: 5px;">
                <div class="col-md-3">
                  <label class="font-weight-bold">SchdM Reviewed</label><br>
                  <input style="margin-top: 10px; margin-right: 5px" type="radio" [(ngModel)]="sch" name="schReview" value="Yes" (change)="reviewdChange('Yes')"> Yes
                  <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" [(ngModel)]="sch" name="schReview" value="No" (change)="reviewdChange('No')"> No
                  @if (schdmReviewedError) {
<span class="form-error-container">SchdM Reviewed is required</span>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">User Reviewed</label>
                  <input type="text" class="form-control" [(ngModel)]="userReviewd" name="userReviewd" readonly>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Reviewed On</label>
                  <input type="text" class="form-control" [(ngModel)]="timestamp" name="timestamp" readonly>
                </div>
              </div>
}

              <!-- SchdM Reviewed, User Reviewed, Reviewed On (readonly mode) -->
              @if (!hideMandatoryFieldCP) {
<div class="row" style="margin-top: 5px;">
                <div class="col-md-3">
                  <label class="font-weight-bold">SchdM Reviewed</label><br>
                  <input style="margin-top: 10px; margin-right: 5px" type="radio" [(ngModel)]="sch" name="schReviewReadonly" value="Yes" disabled> Yes
                  <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" [(ngModel)]="sch" name="schReviewReadonly" value="No" disabled> No
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">User Reviewed</label>
                  <input type="text" class="form-control" [(ngModel)]="userReviewd" name="userReviewdReadonly" readonly>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Reviewed On</label>
                  <input type="text" class="form-control" [(ngModel)]="timestamp" name="timestampReadonly" readonly>
                </div>
              </div>
}

            </div>
}
          </div>

          <!-- Optional Fields Accordion -->
          <div class="panel panel-default wwni-map-accordion">
            <div class="panel-heading" (click)="optionalFieldsOpen = !optionalFieldsOpen" style="cursor: pointer;">
              Optional Fields
              <i class="pull-right glyphicon" [ngClass]="{'glyphicon-chevron-down': optionalFieldsOpen, 'glyphicon-chevron-up': !optionalFieldsOpen}"></i>
            </div>
            @if (optionalFieldsOpen) {
<div class="panel-body">
              <div class="row" style="margin-top: 5px;">
                <div class="col-md-3">
                  <label class="font-weight-bold">Project Name</label>
                  @if (projectLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!projectLoading) {
<select gtwSearchableSelect class="form-control" [(ngModel)]="project" name="projectDcs" (change)="loadProjectSteps()">
                    <option value="">Select a Project Name</option>
                    @for (p of projectsList.list; track $index) {
<option [value]="p.PROJECT_NAME">{{p.PROJECT_NAME}}</option>
}
                  </select>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Project Step Code</label>
                  @if (projectStepLoading) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!projectStepLoading) {

                    @if (project) {
<select gtwSearchableSelect class="form-control" [(ngModel)]="projectStep" name="projectStepDcs">
                      <option value="">Select a Project Step</option>
                      @for (step of projectSteps.list; track $index) {
<option [value]="step.STEP_SHORT_DESCRIPTION">{{step.STEP_SHORT_DESCRIPTION}}</option>
}
                    </select>
}
                    @if (!project) {
<input type="text" class="form-control" [(ngModel)]="projectStep" name="projectStepReadonlyDcs" readonly>
}
                  
}
                </div>
                <div class="col-md-3 numText">
                  <label class="font-weight-bold">Column 2 Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    @if (custom2AmtFlag) {
<input style="text-align: right" type="text" class="form-control" [(ngModel)]="custom2Amt" name="custom2AmtReadonly" readonly>
}
                    @if (!custom2AmtFlag) {
<input style="text-align: right" type="text" class="form-control" [(ngModel)]="custom2Amt" name="custom2Amt">
}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Provision M-1</label><br>
                  <input style="margin-top: 10px; margin-right: 5px" type="radio" [(ngModel)]="provision" name="provisionM1" value="Yes" disabled> Yes
                  <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" [(ngModel)]="provision" name="provisionM1" value="No" disabled> No
                </div>
              </div>

              <div class="row" style="margin-top: 5px;">
                <div class="col-md-3">
                  <label class="font-weight-bold">Settled Y/N?</label><br>
                  <input style="margin-top: 10px; margin-right: 5px" type="radio" [(ngModel)]="settledYesNo" name="settledYesNo" value="Yes"> Yes
                  <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" [(ngModel)]="settledYesNo" name="settledYesNo" value="No"> No
                </div>
                <div class="col-md-6">
                  <label class="font-weight-bold">Comments</label>
                  <input type="text" class="form-control" [(ngModel)]="COMMENTS" name="commentsDcs">
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Trading Partner</label>
                  <div class="input-group">
                    <input type="text" class="form-control input-sm"
                           placeholder="begin typing to select trading partner"
                           [(ngModel)]="tpObjectDDisplay"
                           name="tradingPartnerDcs"
                           (input)="searchTradingPartners($event)">
                    <span class="input-group-addon">
                      @if (loadingTpsDcs) {
<i class="fa fa-spinner fa-pulse"></i>
}
                      @if (!loadingTpsDcs) {
<i class="fa fa-search"></i>
}
                    </span>
                  </div>
                  @if (tpSearchResults.length > 0) {
<div class="tp-dropdown">
                    @for (tp of tpSearchResults; track $index) {
<div class="tp-item" (click)="setTradingPartnerDcs(tp)">
                      {{tp.TP_ENTITY}}
                    </div>
}
                  </div>
}
                </div>
              </div>
            </div>
}
          </div>

          <!-- Reportable Transactions Panel -->
          @if (!hideCgni) {
<div class="panel panel-default">
            <div class="panel-heading">
              Reportable Transactions
              <input style="margin-left: 5px; margin-top: 10px; margin-right: 5px" type="radio" [(ngModel)]="reportable" name="reportableRadio" value="Yes" (change)="clickYes()"> Yes
              <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" [(ngModel)]="reportable" name="reportableRadio" value="No" (change)="clickNo()"> No
            </div>

            @if (rptTFlag === 'Yes') {
<div class="panel-body">
              <div class="row" style="margin: 5px;">
                <div class="col-md-3">
                  <label class="font-weight-bold">Reportable Action</label>
                  <select gtwSearchableSelect class="form-control" [(ngModel)]="transactionType" name="transactionType" [compareWith]="compareReportableOption" (change)="reportableActionChange()">
                    <option value="">Select...</option>
                    @for (t of transactions; track $index) {
<option [ngValue]="t">{{t.CODE_DESC}}</option>
}
                  </select>
                  @if (reportableActionError) {
<span class="form-error-container">Please Select a Reportable Action</span>
}
                </div>
                <div class="col-md-3">
                  <label class="font-weight-bold">Reportable Tax Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">{{dcsCurr}}</span>
                    <input style="text-align: right" type="text" class="form-control" [(ngModel)]="rptTaxAcct" name="rptTaxAcct" (change)="reportableTaxAmountChange()">
                    <span class="input-group-addon">
                      <button type="button" style="border: none; padding: 0; background: none;" (click)="applyTaxAcct()">Apply</button>
                    </span>
                  </div>
                  @if (reportableTaxAmountError) {
<span class="form-error-container">Reportable Tax Amount is required</span>
}
                </div>
              </div>

              <!-- BAA - Book Amount Adjustment section -->
              @if (reportableActionChangeFlag === 'BAA') {

                <div class="row" style="margin: 5px;">
                  <div class="col-md-6">
                    <label class="font-weight-bold">Reportable Transaction Description as per Form 8886, Line 1a:</label>
                    <input class="form-control" [(ngModel)]="reportableTransDesc" name="reportableTransDesc" (change)="rptDescChange()">
                    @if (rptDescError) {
<span class="form-error-container">Reportable Transaction Description is required</span>
}
                  </div>
                  <div class="col-md-4">
                    <label class="font-weight-bold">Tax Shelter Registration Number</label>
                    <input class="form-control" [(ngModel)]="taxShelterRegNum" name="taxShelterRegNum">
                  </div>
                  <div class="col-md-2">
                    <label class="font-weight-bold">Type of Reportable Transaction</label>
                    <select gtwSearchableSelect class="form-control" [(ngModel)]="typeOfReportableTrans" name="typeOfReportableTrans" [compareWith]="compareReportableOption" (change)="typeOfRptTransChange()">
                      <option value="">Select...</option>
                      @for (t of reportableTransList; track $index) {
<option [ngValue]="t">{{t.CODE_DESC}}</option>
}
                    </select>
                    @if (typeOfRptError) {
<span class="form-error-container">Please Select Type of Reportable Transaction</span>
}
                  </div>
                </div>

                <!-- G/L Account rows for BAA -->
                <div class="row" style="margin: 15px;">
                  <div class="col-md-1"></div>
                  <div class="col-md-3"><label class="font-weight-bold">G/L Account</label></div>
                  <div class="col-md-2"><label class="font-weight-bold">CY Amount</label></div>
                  <div class="col-md-2"><label class="font-weight-bold">Earlier Adjustments Amount</label></div>
                  <div class="col-md-2"><label class="font-weight-bold">Adjustments Amount</label></div>
                  <div class="col-md-2"><label class="font-weight-bold">Adjusted CY Amount</label></div>
                </div>
                @for (reportableItem of reportableList; track $index; let idx = $index) {
<div class="row" style="margin: 5px;">
                  <div class="col-md-1">
                    <br><i style="font-size: 24px; cursor: pointer;" class="fa fa-minus-circle color-red" (click)="removeReportable(idx)"></i>
                  </div>
                  <div class="col-md-3">
                    <select gtwSearchableSelect class="form-control" [(ngModel)]="reportableItem.glacct" [name]="'glacct_' + idx" (change)="glacctChange(reportableItem)">
                      <option value="">Select...</option>
                      @for (g of glaccts; track $index) {
<option [ngValue]="g">{{g.GL_ACCT}}</option>
}
                    </select>
                    @if (reportableItem.glacct_error) {
<span class="form-error-container">Please Select a G/L Account</span>
}
                  </div>
                  <div class="col-md-2">
                    <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.cy_amt" [name]="'cy_amt_' + idx" readonly>
                  </div>
                  <div class="col-md-2">
                    <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.earlieradj_amt" [name]="'earlieradj_amt_' + idx" readonly>
                  </div>
                  <div class="col-md-2">
                    <input style="text-align: right" class="form-control" type="number" [(ngModel)]="reportableItem.thisadj_amt" [name]="'thisadj_amt_' + idx" (change)="adjustedAmtChange(idx)">
                    @if (reportableItem.thisadj_amt_error) {
<span class="form-error-container">Adjustments amount cannot be zero</span>
}
                  </div>
                  <div class="col-md-2">
                    <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.adj_cy_amt" [name]="'adj_cy_amt_' + idx" readonly>
                  </div>
                </div>
}

                <!-- Add button row -->
                <div class="row" style="margin: 5px;">
                  <div class="col-md-1">
                    <i style="font-size: 24px; cursor: pointer;" class="fa fa-plus-circle color-green" (click)="addReportable()"></i>
                  </div>
                </div>
              
}

              <!-- ZBA - Zero Book Amount section -->
              @if (reportableActionChangeFlag === 'ZBA') {

                <div class="row" style="margin: 5px;">
                  <div class="col-md-12">
                    <label class="font-weight-bold">Reason for Zero Book Amount:</label>
                    <input class="form-control" [(ngModel)]="reasonForChange" name="reasonForChange" (change)="reasonForZeroBookAmtChange()">
                    @if (reasonForZeroError) {
<span class="form-error-container">Reason for Zero Book Amount is required</span>
}
                  </div>
                </div>
                <div class="row" style="margin: 5px;">
                  <div class="col-md-6">
                    <label class="font-weight-bold">Reportable Transaction Description as per Form 8886, Line 1a:</label>
                    <input class="form-control" [(ngModel)]="reportableTransDesc" name="reportableTransDescZBA" (change)="rptDescChange()">
                    @if (rptDescError) {
<span class="form-error-container">Reportable Transaction Description is required</span>
}
                  </div>
                  <div class="col-md-4">
                    <label class="font-weight-bold">Tax Shelter Registration Number</label>
                    <input class="form-control" [(ngModel)]="taxShelterRegNum" name="taxShelterRegNumZBA">
                  </div>
                  <div class="col-md-2">
                    <label class="font-weight-bold">Type of Reportable Transaction</label>
                    <select gtwSearchableSelect class="form-control" [(ngModel)]="typeOfReportableTrans" name="typeOfReportableTransZBA" [compareWith]="compareReportableOption" (change)="typeOfRptTransChange()">
                      <option value="">Select...</option>
                      @for (t of reportableTransList; track $index) {
<option [ngValue]="t">{{t.CODE_DESC}}</option>
}
                    </select>
                    @if (typeOfRptError) {
<span class="form-error-container">Please Select Type of Reportable Transaction</span>
}
                  </div>
                </div>
              
}

              <!-- DP section -->
              @if (reportableActionChangeFlag === 'DP') {

                <div class="row" style="margin: 5px;">
                  <div class="col-md-6">
                    <label class="font-weight-bold">Reportable Transaction Description as per Form 8886, Line 1a:</label>
                    <input class="form-control" [(ngModel)]="reportableTransDesc" name="reportableTransDescDP" (change)="rptDescChange()">
                    @if (rptDescError) {
<span class="form-error-container">Reportable Transaction Description is required</span>
}
                  </div>
                  <div class="col-md-4">
                    <label class="font-weight-bold">Tax Shelter Registration Number</label>
                    <input class="form-control" [(ngModel)]="taxShelterRegNum" name="taxShelterRegNumDP">
                  </div>
                  <div class="col-md-2">
                    <label class="font-weight-bold">Type of Reportable Transaction</label>
                    <select gtwSearchableSelect class="form-control" [(ngModel)]="typeOfReportableTrans" name="typeOfReportableTransDP" [compareWith]="compareReportableOption" (change)="typeOfRptTransChange()">
                      <option value="">Select...</option>
                      @for (t of reportableTransList; track $index) {
<option [ngValue]="t">{{t.CODE_DESC}}</option>
}
                    </select>
                    @if (typeOfRptError) {
<span class="form-error-container">Please Select Type of Reportable Transaction</span>
}
                  </div>
                </div>
              
}
            </div>
}
          </div>
}

        </div>
}
        <!-- ======================= END SCHDM Adjustments Tab ======================= -->

        <!-- ======================= Book Only Reportable Tab ======================= -->
        @if (activeScheduleTab === 1) {
<div class="book-reportable-tab-content">
          
          <!-- Top Section: Posting Accounts & Book Amt -->
          <div style="margin-bottom: 30px;">
            <div class="row" style="margin-top: 5px;">
              @if (!testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">Posting G/L Account</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="postingGL" name="postingGLBook" readonly>
}
              </div>
}
              @if (testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">Posting Tax Account Code</label>
                <select gtwSearchableSelect class="form-control" [(ngModel)]="postingTaxTopB" name="postingTaxTopB" (change)="newPostingTaxChangeB()">
                  @for (acct of postingGLAcctMB; track $index) {
<option [ngValue]="acct">{{acct}}</option>
}
                </select>
              </div>
}
              @if (!testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">Posting Tax Account Code</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="postingTax" name="postingTaxBook" readonly>
}
              </div>
}
              @if (!testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">M3 Form Line</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<input type="text" class="form-control" [(ngModel)]="m3FormLine" name="m3FormLineBook" readonly>
}
              </div>
}
              @if (testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">M3 Form Line</label>
                @if (!triggerLoadingNew) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoadingNew) {
<input type="text" class="form-control" [(ngModel)]="m3FormLineB" name="m3FormLineBookNew" readonly>
}
              </div>
}
              @if (!testFlag) {
<div class="col-md-3">
                <label class="font-weight-bold">Book Amt</label>
                @if (!triggerLoading) {
<div class="gt-filter-loading">
                  <i style="color: #e12827; font-size: 20px;" class="fa fa-spinner fa-spin"></i>
                </div>
}
                @if (triggerLoading) {
<div class="input-group">
                  <span class="input-group-addon">{{dcsCurr}}</span>
                  <input style="text-align: right" type="text" class="form-control" [value]="formatNumber(bookAmt)" name="bookAmtBook" readonly>
                </div>
}
              </div>
}
            </div>
          </div>

          <!-- M3 Reclass for Reportable Transaction Panel -->
          <div class="panel panel-default">
            <div class="panel-heading">M3 Reclass for Reportable Transaction (Column A)</div>
            <div class="panel-body">
              <div class="row" style="margin: 5px;">
                <div class="col-md-6">
                  <label class="font-weight-bold">Reportable Transaction Description as per Form 8886, Line 1a:</label>
                  <input class="form-control" [(ngModel)]="reportableTransDescBook" name="reportableTransDescBook" (change)="rptDescChangeBook()">
                  @if (rptDescErrorBook) {
<span class="form-error-container">Reportable Transaction Description is required</span>
}
                </div>
                <div class="col-md-4">
                  <label class="font-weight-bold">Tax Shelter Registration Number</label>
                  <input class="form-control" [(ngModel)]="taxShelterRegNumBook" name="taxShelterRegNumBook" (change)="taxShelterChangeBook()">
                  @if (taxShelterErrorBook) {
<span class="form-error-container">Tax Shelter Registration Number is required</span>
}
                </div>
                <div class="col-md-2">
                  <label class="font-weight-bold">Type of Reportable Transaction</label>
                  <select gtwSearchableSelect class="form-control" [(ngModel)]="typeOfReportableTransBook" name="typeOfReportableTransBook" [compareWith]="compareReportableOption" (change)="typeOfRptTransChangeBook()">
                    <option value="">Select...</option>
                    @for (t of reportableTransList; track $index) {
<option [ngValue]="t">{{t.CODE_DESC}}</option>
}
                  </select>
                  @if (typeOfRptErrorBook) {
<span class="form-error-container">Please Select Type of Reportable Transaction</span>
}
                </div>
              </div>

              <!-- G/L Account headers -->
              <div class="row" style="margin: 15px;">
                <div class="col-md-1"></div>
                <div class="col-md-3"><label class="font-weight-bold">G/L Account</label></div>
                <div class="col-md-2"><label class="font-weight-bold">CY Amount</label></div>
                <div class="col-md-2"><label class="font-weight-bold">Earlier Adjustments Amount</label></div>
                <div class="col-md-2"><label class="font-weight-bold">Adjustments Amount</label></div>
                <div class="col-md-2"><label class="font-weight-bold">Adjusted CY Amount</label></div>
              </div>

              <!-- Reportable list rows -->
              @for (reportableItem of reportableListBook; track $index; let idx = $index) {
<div class="row" style="margin: 5px;">
                <div class="col-md-1">
                  <br><i style="font-size: 24px; cursor: pointer;" class="fa fa-minus-circle color-red" (click)="removeReportableBook(idx)"></i>
                </div>
                <div class="col-md-3">
                  <select gtwSearchableSelect class="form-control" [(ngModel)]="reportableItem.glacct_book" [name]="'glacct_book_' + idx" (change)="glacctChangeBook(reportableItem)">
                    <option value="">Select...</option>
                    @for (g of glaccts; track $index) {
<option [ngValue]="g">{{g.GL_ACCT}}</option>
}
                  </select>
                  @if (reportableItem.glacct_error_book) {
<span class="form-error-container">Please Select a G/L Account</span>
}
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.cy_amt_book" [name]="'cy_amt_book_' + idx" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.earlieradj_amt_book" [name]="'earlieradj_amt_book_' + idx" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" type="number" [(ngModel)]="reportableItem.thisadj_amt_book" [name]="'thisadj_amt_book_' + idx" (change)="adjustedAmtChangeBook(idx)">
                  @if (reportableItem.thisadj_amt_error_book) {
<span class="form-error-container">Adjustments amount cannot be zero</span>
}
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="reportableItem.adj_cy_amt_book" [name]="'adj_cy_amt_book_' + idx" readonly>
                </div>
              </div>
}

              <!-- Offset account row -->
              <div class="row" style="margin: 5px;">
                <div class="col-md-1"></div>
                <div class="col-md-3">
                  <input class="form-control" [(ngModel)]="glacct1Book" name="glacct1Book" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="cyAmt1Book" name="cyAmt1Book" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="earlierAdjAmt1Book" name="earlierAdjAmt1Book" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="thisAdjAmt1Book" name="thisAdjAmt1Book" readonly>
                </div>
                <div class="col-md-2">
                  <input style="text-align: right" class="form-control" [(ngModel)]="adjCyAmt1Book" name="adjCyAmt1Book" readonly>
                </div>
              </div>

              <!-- Add button and total -->
              <div class="row" style="margin: 5px;">
                <div class="col-md-1">
                  <i style="font-size: 24px; cursor: pointer;" class="fa fa-plus-circle color-green" (click)="addReportableBook()"></i>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2"></div>
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <div class="input-group">
                    <span class="input-group-addon">USD</span>
                    <input style="text-align: right" type="text" class="form-control" [(ngModel)]="totalThisAdjAmtStaticBook" name="totalThisAdjAmtStaticBook" readonly>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
            </div>
          </div>

          <!-- Existing Book Reportable transactions table -->
          @if (!testFlag) {
<div style="margin-left: 30px; margin-right: 30px;">
            <div class="table-responsive">
              <table class="table table-hover table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th style="text-align: center; width: 5%;">Edit</th>
                    <th>G/L Account</th>
                    <th>Adjustment Amount</th>
                    <th>Updated By</th>
                    <th>Last Updated</th>
                  </tr>
                </thead>
                @if (existingChartLoading) {
<tbody>
                  <tr>
                    <td class="loading-table" colspan="5"><i style="margin-top: 20px" class="fa fa-2x fa-spinner fa-pulse"></i></td>
                  </tr>
                </tbody>
}
                @if (noRecordsBook && !existingChartLoading) {
<tbody>
                  <tr>
                    <td class="loading-table" colspan="5"><div style="margin-top: 40px"><b>No Existing Transaction</b></div></td>
                  </tr>
                </tbody>
}
                @if (!existingChartLoading) {
<tbody>
                  @for (adj of existingChartData; track $index; let i = $index) {
<tr>
                    <td align="center" (click)="loadAdjustmentBook(i)"><span><a href="javascript:void(0)"><i class="fa fa-pencil"></i> Edit</a></span></td>
                    <td>{{adj.GL_ACCT}}</td>
                    <td>{{adj.ADJ_AMOUNT}}</td>
                    <td>{{adj.UPDATED_BY}}</td>
                    <td>{{adj.UPDATED_ON}}</td>
                  </tr>
}
                </tbody>
}
              </table>
            </div>
          </div>
}
        </div>
}
        <!-- ======================= END Book Only Reportable Tab ======================= -->

      
}
      <!-- ======================= END DCS TEMPLATE ======================= -->

    </form>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (!reportableFlag) {

    @if (!viewOnly) {
<button
            class="btn btn-info"
            type="button"
            [disabled]="isSaveClicked"
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
}
    @if (!viewOnly) {
<button
            class="btn btn-danger-outline"
            type="button"
            (click)="reset()">Reset</button>
}
    <button class="btn btn-warning"
            type="button"
            (click)="cancel()">Cancel</button>
  
}

  @if (reportableFlag) {

    <button class="btn btn-info"
            type="button"
            [disabled]="crudLoadingBook"
            (click)="save1()">
      @if (crudLoadingBook) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-danger-outline"
            type="button"
            (click)="reset1()">Reset</button>
    <button class="btn btn-warning"
            type="button"
            (click)="cancel1()">Cancel</button>
  
}
</div>

<!-- Existing Adjustments Table -->
@if (showTaxAdjForm && !testFlag && activeScheduleTab === 0) {
<div class="existing-adjustments" [hidden]="minimise">
  <div class="table-responsive" style="margin: 0 30px;">
    <table class="gt-adj-table table table-hover table-bordered table-striped table-condensed">
      <thead>
        <!-- FIR Headers -->
        @if (SOURCE_SYSTEM === 'FIR') {
<tr>
          <th></th>
          <th style="text-align: center;">Edit</th>
          <th style="text-align: center;">Delete</th>
          <th>Tax Adj Description</th>
          <th>Supplemental Info</th>
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Issue ID</th>
}
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Scenario</th>
}
          <th>Last Updated</th>
          <th>Updated By</th>
        </tr>
}
        <!-- DCS Headers -->
        @if (SOURCE_SYSTEM === 'DCS') {
<tr class="dcs-header-row">
          <th style="text-align: center;">Edit</th>
          <th>Adj Source</th>
          <th>User M-1 Desc</th>
          <th>SchdM Type</th>
          <th>TBBS Acct</th>
          <th>CY Schd M-1 Amount</th>
          <th>Provision Y/N</th>
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Issue ID</th>
}
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Scenario</th>
}
          <th>Last Updated</th>
          <th>Updated By</th>
        </tr>
}
      </thead>

      @if (existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" [attr.colspan]="SOURCE_SYSTEM === 'FIR' ? 9 : 11">
            <i style="margin-top:20px" class="fa fa-2x fa-spinner fa-pulse"></i>
          </td>
        </tr>
      </tbody>
}

      @if (noRecords && !existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" [attr.colspan]="SOURCE_SYSTEM === 'FIR' ? 9 : 11">
            <div style="margin-top:40px"><b>No Existing Adjustments</b></div>
          </td>
        </tr>
      </tbody>
}

      @if (!existingLoading) {
<tbody>
        @for (adj of existingAdjustments; track $index; let i = $index) {

          <!-- FIR Row -->
          @if (SOURCE_SYSTEM === 'FIR') {
<tr>
            <td align="center">
              @if (!adj.open) {
<i
                 (click)="showDetails(i, true)"
                 style="font-size:20px; cursor:pointer;"
                 class="fa fa-plus-circle"></i>
}
              @if (adj.open) {
<i
                 (click)="showDetails(i, false)"
                 style="font-size:20px; cursor:pointer;"
                 class="fa fa-minus-circle"></i>
}
            </td>
            <td align="center">
              @if (adj.IS_ADJ_EDITABLE === 'Y') {
<span>
                <a href="javascript:void(0)" (click)="loadAdjustment(i)">
                  <i class="fa fa-pencil"></i> Edit
                </a>
              </span>
}
            </td>
            <td align="center">
              @if (adj.IS_ADJ_EDITABLE === 'Y') {
<span>
                <a href="javascript:void(0)" (click)="deleteAdjustment(adj)">
                  <i class="fa fa-times"></i>
                </a>
              </span>
}
            </td>
            <td>{{adj.ADJ_DESC}}</td>
            <td>{{adj.SUPPL_INFO}}</td>
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{adj.ISSUE_ID}}</td>
}
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{adj.SCENARIO}}</td>
}
            <td>{{adj.UPDATED_ON}}</td>
            <td>{{adj.UPDATED_BY}}</td>
          </tr>
}

          <!-- DCS Row -->
          @if (SOURCE_SYSTEM === 'DCS') {
<tr>
            <td align="center">
              <a href="javascript:void(0)" (click)="loadAdjustment(i)">
                <i class="fa fa-pencil"></i> Edit
              </a>
            </td>
            <td>{{adj.ADJ_SOURCE}}</td>
            <td>{{adj.USER_M1_DESC}}</td>
            <td>{{adj.SCHDM_TYPE}}</td>
            <td>{{adj.TBBS_ACCT}}</td>
            <td>{{adj.CY_M1_AMT | number:'1.0-0'}}</td>
            <td>{{adj.PROVISION_M1}}</td>
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{adj.ISSUE_ID}}</td>
}
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{adj.SCENARIO}}</td>
}
            <td>{{adj.UPDATED_ON}}</td>
            <td>{{adj.UPDATED_BY}}</td>
          </tr>
}

          <!-- Expanded Details Row (FIR) -->
          @if (adj.ACCOUNTS && adj.open && SOURCE_SYSTEM === 'FIR') {
<tr>
            <td colspan="9" style="background-color:#cdcdcd">
              <table class="table table-hover table-bordered table-striped table-condensed-xs">
                <thead>
                  <tr>
                    <th colspan="2">Account Details</th>
                    <th>Trading Partner</th>
                    <th>Multiplier</th>
                    <th>5471 Sch H Line</th>
                    <th>Adjustment Amount</th>
                    <th>Project Name</th>
                    <th>Project Step Code</th>
                    <th>FFR Doc</th>
                  </tr>
                </thead>
                <tbody>
                  @for (account of adj.ACCOUNTS; track $index) {
<tr>
                    <td class="text-bg">
                      @if (account.ROW_INDICATOR === 2) {
<span><strong>Income Statement Details</strong></span>
}
                      @if (account.ROW_INDICATOR > 2) {
<span><strong>Balance Sheet Details</strong></span>
}
                    </td>
                    <td>{{account.LOCAL_ACCT}} - {{account.LOCAL_ACCT_DESC}}</td>
                    <td>{{account.TP_ENTITY}}</td>
                    <td>{{account.MULTIPLIER}}</td>
                    <td>{{account.SCHD_H_LINE_NO}}</td>
                    <td class="text-right">{{account.ADJ_AMT | number:'1.0-0'}}</td>
                    <td>{{account.PROJECT_NAME}}</td>
                    <td>{{account.STEP_SHORT_DESCRIPTION}}</td>
                    <td></td>
                  </tr>
}
                </tbody>
              </table>
            </td>
          </tr>
}
        
}
      </tbody>
}
    </table>
  </div>
</div>
}

</div><!-- end modal-scroll-content -->

<!-- SchdM Reviewed Modal Overlay -->
@if (showSchdMModal) {
<div class="schdm-modal-overlay" (click)="closeSchdMModal()">
  <div class="schdm-modal-container" (click)="$event.stopPropagation()">
    <div class="schdm-modal-header">
      <span class="schdm-modal-title">SchdM Reviewed</span>
      <i class="fa fa-times schdm-close-btn" (click)="closeSchdMModal()"></i>
    </div>
    <div class="schdm-modal-body">
      <div class="row">
        <div class="col-sm-3">
          <div>
            <input type="radio" name="schdm_is_public" [value]="0" [(ngModel)]="schdMComment.is_public"> Private
          </div>
        </div>
        <div class="col-sm-9">
          <label class="font-weight-bold">Subject</label>
          <input type="text" class="form-control" [(ngModel)]="schdMComment.subject" placeholder="">

          <label class="font-weight-bold" style="margin-top: 8px;">Message</label>
          <textarea class="form-control" [(ngModel)]="schdMComment.message" placeholder="add message"
                    style="height: 120px;"></textarea>
        </div>
      </div>

      <div class="row" style="margin-top: 10px;">
        <div class="col-sm-12">
          <label class="font-weight-bold">Notify Users</label>
          <div class="input-group">
            <input type="text"
                   class="form-control input-sm"
                   placeholder="Type SSO or Last, First"
                   [ngModel]="schdMUserSearch"
                   (input)="searchSchdMUsers($event)">
            <span class="input-group-addon">
              @if (schdMUserLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
              @if (!schdMUserLoading) {
<i class="fa fa-search"></i>
}
            </span>
          </div>
          @if (schdMUserResults.length > 0) {
<div class="schdm-user-dropdown">
            @for (user of schdMUserResults; track $index) {
<div class="schdm-user-item" (click)="addSchdMNotifyUser(user)">
              {{ user.NAME }}
            </div>
}
          </div>
}
          @if (schdMComment.notify.length > 0) {
<div class="schdm-notify-list">
            @for (u of schdMComment.notify; track $index; let ni = $index) {
<div class="btn-group btn-group-xs" style="margin: 0 5px 5px 0;">
              <div class="btn btn-xs btn-default"><i class="fa fa-user"></i></div>
              <div class="btn btn-default btn-xs">{{ u.NAME }}</div>
              <div class="btn btn-danger btn-xs" (click)="removeSchdMNotifyUser(ni)"><i class="fa fa-times"></i></div>
            </div>
}
          </div>
}
        </div>
      </div>
    </div>
    <div class="schdm-modal-footer">
      <button class="btn btn-info btn-sm" type="button" (click)="saveSchdMComment()" [disabled]="schdMSaving">
        @if (schdMSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
      <button class="btn btn-warning btn-sm" type="button" (click)="closeSchdMModal()">Cancel</button>
    </div>
  </div>
</div>
}
